import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Header from './components/Header';
import PongGame from './components/PongGame';
import Footer from './components/Footer';
import API from './services/api';
import './App.css';

function App() {
  const [visitorId, setVisitorId] = useState(null);

  useEffect(() => {
    // Get or create visitor ID
    let storedVisitorId = localStorage.getItem('loafy_visitor_id');

    if (!storedVisitorId) {
      storedVisitorId = uuidv4();
      localStorage.setItem('loafy_visitor_id', storedVisitorId);
    }

    setVisitorId(storedVisitorId);

    // Track visitor
    const trackVisitor = async () => {
      const referrer = document.referrer || '';
      const path = window.location.pathname;

      await API.trackVisitor(storedVisitorId, path, referrer);
    };

    trackVisitor();
  }, []);

  return (
    <div className="App">
      <Header />
      <main className="main-content">
        {visitorId && <PongGame visitorId={visitorId} />}
      </main>
      <Footer />
    </div>
  );
}

export default App;
